import { useEffect, useMemo } from 'react';
import { isSignUpOrganizationEnabled } from 'common/validators';
import { useSetUser } from 'features/auth';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useOrganizationDetailQuery } from 'features/organizations/queries';
import { useProfileNodeQuery, useProfileQuery } from '../../queries';
import { useSetBrandingLogo } from '../../storages';

export const useFetchUserData = () => {
  const setUser = useSetUser();
  const setBrandingLogo = useSetBrandingLogo();

  const {
    data: railsUser,
    error: railsError,
    isLoading,
  } = useProfileQuery({
    throwOnError: false,
  });

  const { data: nodeUser, error: nodeError, isLoading: isLoadingNode } = useProfileNodeQuery({ throwOnError: false });

  const { data: primaryOrganization, isLoading: isPrimaryLoading } = useOrganizationDetailQuery({
    options: { staleTime: 24 * 60 * 60 * 1000 },
    organizationId: isSignUpOrganizationEnabled() ? railsUser?.primaryOrganizationId : undefined,
  });

  useEffect(() => {
    if (railsUser && nodeUser) {
      setUser({ nodeUserData: nodeUser, railsUserData: railsUser });
    }
  }, [nodeUser, railsUser, setUser]);

  useEffect(() => {
    if (primaryOrganization) {
      setBrandingLogo(primaryOrganization.landscapeLogo);
    }
  }, [primaryOrganization, setBrandingLogo]);

  return useMemo(
    () => ({
      isLoading: isLoading || isLoadingNode || isPrimaryLoading,
      nodeError,
      railsError,
    }),
    [isLoading, isLoadingNode, isPrimaryLoading, nodeError, railsError],
  );
};
